@switch (promotionType$ | async) {
  @case ('DefaultCoupon') {
    <rma-default-coupon-banner [bannerStyle]="bannerStyle" />
  }
  @case ('BlackFriday') {
    <rma-black-friday-banner [bannerStyle]="bannerStyle" />
  }
  @case ('CyberMonday') {
    <rma-cyber-monday-banner [bannerStyle]="bannerStyle" />
  }
  @case ('SummerSale') {
    <rma-summer-sale-banner [bannerStyle]="bannerStyle" />
  }
  @case ('MarchMadness') {
    <rma-march-madness-banner [bannerStyle]="bannerStyle" />
  }
  @case ('EOFY') {
    <rma-eofy-banner [bannerStyle]="bannerStyle" />
  }
  @case ('Remax5Star') {
    <rma-remax-banner [hasReviews]="false" [bannerStyle]="bannerStyle" />
  }
  @case ('RemaxGoogle') {
    <rma-remax-banner [hasReviews]="true" [bannerStyle]="bannerStyle" />
  }
  @case ('AwardWinner') {
    <rma-award-winner-banner [bannerStyle]="bannerStyle" />
  }
}
